import { ResizerEnv } from "./get-resizer-domain";

const domains: { [key in ResizerEnv]: string } = {
  dev: "gateway.ifit-dev.com",
  test: "gateway.ifit-test.com",
  // tslint:disable-next-line: object-literal-sort-keys
  production: "gateway.ifit.com"
};

export const getGatewayDomain = (env: ResizerEnv | string) => {
  return domains[env || "dev"] || domains.dev;
};
